import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

export const Contact = () => {
  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    companyUrl: "",
    designation: "",
    message: "",
  };

  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState("Send");

  const onFormUpdate = (category, value) => {
    setFormDetails({ ...formDetails, [category]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonText("Sending...");

    const { firstName, lastName, email, phone, companyUrl, designation, message } = formDetails;

    if (!firstName || !lastName || !email || !message) {
      toast.error("Please fill in all required (*) fields.");
      setButtonText("Send");
      return;
    }

    const serviceID = "service_j7tnhiq";
    const templateID = "template_mha4c3n";
    const publicKey = "aJtTY6VNtanEncBna";

    const templateParams = { firstName, lastName, email, phone, companyUrl, designation, message };

    try {
      const response = await emailjs.send(serviceID, templateID, templateParams, publicKey);

      if (response.status === 200) {
        toast.success("Thank you for reaching out! I will get back to you as soon as possible.");
        setFormDetails(formInitialDetails);
      } else {
        toast.error("Something went wrong, please try again later.");
      }
    } catch (error) {
      toast.error(`Error: ${error.text || error.message}`);
    } finally {
      setButtonText("Send");
    }
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img className={isVisible ? "animate__animated animate__zoomIn" : ""} src={contactImg} alt="Contact Us" />
              )}
            </TrackVisibility>
          </Col>
          <Col md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Get In Touch</h2>
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={6} className="px-1">
                        <label>First Name *</label>
                        <input
                          type="text"
                          value={formDetails.firstName}
                          placeholder="First Name"
                          onChange={(e) => onFormUpdate("firstName", e.target.value)}
                          required
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <label>Last Name *</label>
                        <input
                          type="text"
                          value={formDetails.lastName}
                          placeholder="Last Name"
                          onChange={(e) => onFormUpdate("lastName", e.target.value)}
                          required
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <label>Email Address *</label>
                        <input
                          type="email"
                          value={formDetails.email}
                          placeholder="Email Address"
                          onChange={(e) => onFormUpdate("email", e.target.value)}
                          required
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <label>Phone No. *</label>
                        <input
                          type="tel"
                          value={formDetails.phone}
                          placeholder="Phone No."
                          onChange={(e) => onFormUpdate("phone", e.target.value)}
                          required
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <label>Company URL (Optional)</label>
                        <input
                          type="text"
                          value={formDetails.companyUrl}
                          placeholder="Company URL"
                          onChange={(e) => onFormUpdate("companyUrl", e.target.value)}
                        />
                      </Col>
                      <Col sm={6} className="px-1">
                        <label>Your Designation (Optional)</label>
                        <input
                          type="text"
                          value={formDetails.designation}
                          placeholder="Your Designation"
                          onChange={(e) => onFormUpdate("designation", e.target.value)}
                        />
                      </Col>
                      <Col className="px-1">
                        <label>Message *</label>
                        <textarea
                          rows="6"
                          value={formDetails.message}
                          placeholder="Message"
                          onChange={(e) => onFormUpdate("message", e.target.value)}
                          required
                        ></textarea>
                        <button type="submit"><span>{buttonText}</span></button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <Row id="contact-info-box" className="justify-content-center text-center mt-5">
        <Col md={6} className="px-3">
          <div
            style={{
              background: "rgba(255, 255, 255, 0.12)",
              padding: "28px 32px",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              backdropFilter: "blur(6px)",
              maxWidth: "520px",
              margin: "0 auto",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                color: "#ffffff",
                fontWeight: 600,
                marginBottom: "8px",
              }}
            >
              Get in Touch
            </h3>

            <p
              style={{
                fontSize: "15px",
                color: "#e0e0e0",
                marginBottom: "18px",
                lineHeight: "1.6",
              }}
            >
              For project discussions, collaborations, or professional inquiries,
              feel free to reach out via email or WhatsApp.
            </p>

            {/* Email */}
            <p
              style={{
                fontSize: "16px",
                fontWeight: 500,
                marginBottom: "14px",
              }}
            >
              <FontAwesomeIcon
                icon={faEnvelope}
                style={{ marginRight: "8px", color: "#d1d1d1" }}
              />
              <a
                href="mailto:mohitarora321123@gmail.com"
                style={{
                  color: "#d1d1d1",
                  textDecoration: "none",
                }}
              >
                mohitarora321123@gmail.com
              </a>
            </p>

            {/* WhatsApp */}
            <p
              style={{
                fontSize: "16px",
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <FontAwesomeIcon
                icon={faWhatsapp}
                style={{ color: "#25D366", fontSize: "18px" }}
              />
              <a
                href="https://wa.me/917009965674?text=Hi%20Mohit,%20I%20would%20like%20to%20discuss%20a%20project."
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#ffffff",
                  textDecoration: "none",
                  fontWeight: 500,
                }}
              >
                Connect via WhatsApp
              </a>

            </p>
          </div>
        </Col>
      </Row>


      {/* Toast Container for Notifications */}
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar closeOnClick />
    </section>
  );
};
